import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup } from 'react-transition-group';
import { RemoveScroll } from 'react-remove-scroll';

import {
    Breakpoint,
    BREAKPOINTS
} from 'tradera-components/breakpoint/breakpoint';
import {
    EnterFrom,
    EnterFade
} from 'tradera-components/transitions/transitions';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary/application-error-boundary';
import Overlay from 'components/modals/overlay';
import ProfileMenuContent from './profile-menu-content';
import SignInMenuContent from './sign-in-menu-content';

const ProfileMenu = props => {
    const {
        className,
        dismissSwish,
        expanded,
        handleExpand,
        logOut,
        member,
        redirectUrl,
        showMessagingLink,
        systemMessages,
        threadsUnread,
        transparentHeader
    } = props;

    const {
        cleanedMemberAlias,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberHeroImage,
        memberId
    } = member;

    const showPayments1Menu =
        member.paymentSettings && member.paymentSettings.showPayments1Menu;

    const showPayments2Menu =
        member.paymentSettings && member.paymentSettings.showPayments2Menu;

    const renderChild = () => (
        <RemoveScroll forwardProps>
            <div className="site-dropdown profile-menu">
                {isLoggedIn ? (
                    <ProfileMenuContent
                        cleanedMemberAlias={cleanedMemberAlias}
                        dismissSwish={dismissSwish}
                        logOut={logOut}
                        memberAlias={memberAlias}
                        memberDetailedSellerRatingAverage={
                            memberDetailedSellerRatingAverage
                        }
                        memberHeroImage={memberHeroImage}
                        memberId={memberId}
                        showMessagingLink={showMessagingLink}
                        showPayments1Menu={showPayments1Menu}
                        showPayments2Menu={showPayments2Menu}
                        systemMessages={systemMessages}
                        threadsUnread={threadsUnread}
                    />
                ) : (
                    <SignInMenuContent
                        closeMenu={handleExpand}
                        redirectUrl={redirectUrl}
                    />
                )}
            </div>
        </RemoveScroll>
    );

    return (
        <ApplicationErrorBoundary>
            <nav className={className || ''} role="navigation">
                <TransitionGroup component={null} mountOnEnter>
                    {expanded && (
                        <EnterFade in={expanded}>
                            <Overlay
                                style={{
                                    zIndex: 4,
                                    top: transparentHeader ? '0' : '3.5rem',
                                    height: transparentHeader
                                        ? '100vh'
                                        : 'calc(100vh - 3.5rem)'
                                }}
                                show={expanded}
                                closeModalCallback={handleExpand}
                            />
                        </EnterFade>
                    )}

                    {expanded && (
                        <EnterFrom from="right" in={expanded}>
                            <Breakpoint upTo={BREAKPOINTS.LG}>
                                {renderChild()}
                            </Breakpoint>
                        </EnterFrom>
                    )}
                </TransitionGroup>
                {expanded && (
                    <Breakpoint is={BREAKPOINTS.XL}>{renderChild()}</Breakpoint>
                )}
            </nav>
        </ApplicationErrorBoundary>
    );
};

ProfileMenu.defaultProps = {
    expanded: false
};

ProfileMenu.propTypes = {
    className: PropTypes.string,
    dismissSwish: PropTypes.func.isRequired,
    expanded: PropTypes.bool,
    logOut: PropTypes.func.isRequired,
    member: PropTypes.shape({
        cleanedMemberAlias: PropTypes.string,
        isLoggedIn: PropTypes.bool.isRequired,
        memberAlias: PropTypes.string,
        memberDetailedSellerRatingAverage: PropTypes.number,
        memberHeroImage: PropTypes.object,
        memberId: PropTypes.number
    }),
    showMessagingLink: PropTypes.bool,
    systemMessages: PropTypes.object,
    threadsUnread: PropTypes.number
};

export default ProfileMenu;
